export default "__VITE_ASSET__BxN04Qup__"